/**
 * Contact Form API Service
 * Handles communication with the contact form Lambda endpoint
 */

import {post} from "aws-amplify/api";
import {ContactFormData, ContactResponse, ContactErrorResponse} from "../types/contactFormTypes";

/**
 * Submit contact form data to the API
 *
 * @param data - Contact form submission data
 * @param jwtToken - Optional JWT authentication token (for authenticated users)
 * @returns Contact response or throws error
 * @throws ContactErrorResponse on API errors
 */
export const submitContactForm = async (data: ContactFormData, jwtToken?: string): Promise<ContactResponse> => {
  try {
    console.log("[ContactForm] Submitting contact form");

    const options: any = {
      body: data,
      withCredentials: false // Disable automatic Cognito auth for public endpoint
    };

    // Note: Contact form is a public endpoint - no authentication required

    const {body} = await post({
      apiName: "data",
      path: "/contact",
      options: options
    }).response;

    const result = (await body.json()) as any;

    console.log("[ContactForm] Submission successful");

    return result as ContactResponse;
  } catch (error: any) {
    // Parse API Gateway error response
    if (error.response) {
      const errorData = (await error.response.body.json()) as any;
      throw {
        error: {
          code: errorData.error?.code || "UNKNOWN_ERROR",
          message: errorData.error?.message || "Failed to submit contact form",
          statusCode: error.response.statusCode,
          details: errorData.error?.details
        }
      } as ContactErrorResponse;
    }

    // Network or other errors
    throw {
      error: {
        code: "NETWORK_ERROR",
        message: error.message || "Failed to connect to contact form service",
        statusCode: 0
      }
    } as ContactErrorResponse;
  }
};
